import { type FC } from 'react'
import { IconButton, toastStore } from 'shared/ui'
import { createAndDownloadFileFromText, DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import type { IAudioPlayerTranscriptItem } from 'shared/ui/AudioPlayer'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import styles from './styles.module.scss'

type ITranscriptActionsProps = {
  items: IAudioPlayerTranscriptItem[]
}

export const TranscriptActions: FC<ITranscriptActionsProps> = ({ items }) => {
  const text = items
    .map((item, index) => {
      const isLast = items.length === index + 1
      const title = `${item.speaker_label} ${item.speaker_number}`

      if (isLast) return `${title}\n${item.text}`

      return `${title}\n${item.text}\n\n`
    })
    .join('')
  const { onCopy } = useCopyToClipboard(text, { showToast: true, mode: 'stateless' })

  const onDownload = () => {
    const fileName = `Download ${uiStore.dayjs().format(DayjsFormats.fullDownload)}.txt`
    createAndDownloadFileFromText(fileName, text)
    toastStore.add({
      title: 'File downloaded',
      type: 'info',
    })
  }

  return (
    <div className={styles.actions}>
      <IconButton
        onClick={onCopy}
        icon={'copy'}
        variant={'icon'}
        size={'small'}
        color={'tertiary'}
        transparentInactive
        fontSize={16}
        tooltipProps={{
          label: 'Copy transcript',
          placement: 'top',
        }}
        ariaLabel='Transcription_copy'
      />
      <IconButton
        onClick={onDownload}
        icon={'download'}
        variant={'icon'}
        size={'small'}
        color={'tertiary'}
        transparentInactive
        fontSize={16}
        tooltipProps={{
          label: 'Download transcript',
          placement: 'top',
        }}
        ariaLabel='Transcription_download'
      />
    </div>
  )
}
